module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraLight.b5f21e3a.ttf";